<template>
  <div class="template">
    <div
      class="fixed-header"
      :class="{ 'hide-header': !isMobileHeaderTitleVisible && isMobileScreen }"
    >
      <HeaderBar />
      <slot name="search"></slot>
    </div>
    <slot></slot>

    <HeaderMobileNavBar v-if="isMobileScreen" />
  </div>
</template>

<script setup>
import { useBreakpointHelper } from '@/composables/breakpointHelper';

const { isBelowCurrentBreakpoint } = useBreakpointHelper();
const isMobileScreen = computed(() => isBelowCurrentBreakpoint('tw-md'));

const route = useRoute();
const isMobileHeaderTitleVisible = ref(true);

const handleScroll = () => {
  if (isMobileScreen.value) {
    if (window.scrollY > 0) {
      isMobileHeaderTitleVisible.value = false;
    } else {
      isMobileHeaderTitleVisible.value = true;
    }
  }
};

onMounted(() => {
  if (route.path !== '/staged') {
    window.addEventListener('scroll', handleScroll);
  }
});

onUnmounted(() => {
  if (route.path !== '/staged') {
    window.removeEventListener('scroll', handleScroll);
  }
});
</script>
<style lang="scss" scoped>
@use '@/assets/scss/container.scss';
</style>
